import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import ModalCustomized from '../../../../components/Modal/Modal';

export default function ModalModeloImpressao({ isOpen, toggle, handlePrintSimplificada, handlePrintCompleta }) {
    return (
        <ModalCustomized
            toggle={toggle}
            isOpen={isOpen}
            btnClose={toggle}
            size={'lg'}
            fullscreen={"lg"}
            widthPadrao={false}
            title={"Selecionar Modelo de Impressão"}
        >
            <Row className='d-flex flex-column justify-content-center align-items-center mt-2'>
                <Col md={12} lg={12} className="mb-2">
                    <Button
                        color='secondary'
                        className='text-white fw-bold w-100'
                        onClick={handlePrintSimplificada}
                    >
                        <FontAwesomeIcon icon={faFilePdf} className="me-2" /> Ficha Simplificada
                    </Button>
                </Col>
                <Col md={12} lg={12} className="mb-2 mt-2">
                    <Button
                        color='secondary'
                        className='text-white fw-bold w-100'
                        onClick={handlePrintCompleta}
                    >
                        <FontAwesomeIcon icon={faFilePdf} className="me-2" /> Ficha Completa
                    </Button>
                </Col>
            </Row>
        </ModalCustomized>
    );
}
